import quotedSvg from "@/assets/quoted.gif";
import Button from "@/lib/Button";
import useToPage from "@/lib/useToPage";
import { useFetchRfq } from "@/lib/queries/hooks";
import useGetCurrentQuoteRevision from "@/lib/SelectedQuoteRevisionIdContext/useGetCurrentQuoteRevision";
import useCreateQuoteRevision from "@/lib/queries/useCreateQuoteRevision";
import Print from "@/lib/Print";
import { useParams } from "react-router";
import Download from "@/lib/Download";

export default function Done() {
  const { toRfq } = useToPage();
  const createQuoteRevision = useCreateQuoteRevision();
  const rfq = useFetchRfq();
  const quoteRevision = useGetCurrentQuoteRevision();
  const { teamSlug } = useParams();

  if (!rfq || !quoteRevision) {
    return null;
  }

  const rfq_number = rfq.rfq_number;
  const quotePdfUrl = `/api/teams/${teamSlug}/quote_revisions/${quoteRevision.id}/quote.pdf`;

  return (
    <div className="w-full h-full flex flex-col p-4">
      <div className="flex gap-1 self-end">
        <Print fileUrl={quotePdfUrl} />
        <Download fileUrl={quotePdfUrl} />
      </div>
      <div className="w-full grow flex justify-center items-center">
        <div className="w-full max-w-[470px] bg-white p-6 flex flex-col gap-2">
          <div className="font-semibold text-2xl">Quote Complete</div>
          <img className="self-center" src={quotedSvg} />
          <div className="text-lg font-bold">RFQ {rfq_number}</div>
          <div className="w-full flex gap-2 justify-between items-center px-3 py-1 mt-8">
            <Button onClick={() => toRfq()}>View RFQ Detail</Button>
            <Button primary onClick={createQuoteRevision}>
              Revise Quote
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
